export default class ConfigParametrosController {
  constructor($q, AuthenticationService, AdministrationService, UIService, Instituicao, EntidadeFinanciadora, AreaInterdisciplinar, ParametrosDiversos, Pais) {
    this.$q = $q;
    this.UI = UIService;
    this.Auth = AuthenticationService;
    this.AdministrationService = AdministrationService;
    this.user = this.Auth.getUser();
    this.Instituicao = Instituicao;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.ParametrosDiversos = ParametrosDiversos;
    this.Pais = Pais;
    this.instituicoesLoading = false;
    this.entidadesFinanciadorasLoading = false;
    this.areasInterdisciplinaresLoading = false;
    this.parametrosDiversosLoading = false;
    this.instituicoes = null; // Variable with an array of parameters (from db)
    this.entidadesFinanciadoras = null; // Variable with an array of parameters (from db)
    this.areasInterdisciplinares = null; // Variable with an array of parameters (from db)
    this.parametrosDiversos = null; // Variable with an array of parameters (from db)
    this.focusParametros = null; // Year to be shown
    this.showInstituicoesFab = false;
    this.showEntidadesFinanciadorasFab = false;
    this.showAreasInterdisciplinaresFab = false;
    this.showParametrosDiversosFab = false;

    this.optInstituicoes = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 20,
      order: "designacao",
      sort: "asc",
    };

    this.optEntidadesFinanciadoras = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 20,
      order: "designacao",
      sort: "asc",
    };

    this.optAreasInterdisciplinares = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 20,
      order: "designacao",
      sort: "asc",
    };

    this.getInstituicoes();
    this.getEntidadesFinanciadoras();
    this.getAreasInterdisciplinares();
    this.getParametrosDiversos();
  }

  configLoading = () => {
    return this.instituicoesLoading || this.entidadesFinanciadorasLoading || this.areasInterdisciplinaresLoading ||this.parametrosDiversosLoading;
  };

  updateFab = (f) => {
    if (f === 'instituicoes') { // instituicoes tab
      this.showInstituicoesFab = true;
      this.showEntidadesFinanciadorasFab = false;
      this.showAreasInterdisciplinaresFab = false;
      this.showParametrosDiversosFab = false;
    } else if (f === 'entidadesFinanciadoras') { // entidades financiadoras tab
      this.showInstituicoesFab = false;
      this.showEntidadesFinanciadorasFab = true;
      this.showAreasInterdisciplinaresFab = false;
      this.showParametrosDiversosFab = false;
    } else if (f === 'areasInterdisciplinares') { // areas interdisciplinares tab
      this.showInstituicoesFab = false;
      this.showEntidadesFinanciadorasFab = false;
      this.showAreasInterdisciplinaresFab = true;
      this.showParametrosDiversosFab = false;
    } else if (f === 'parametrosDiversos') { // parametros diversos tab
      this.showInstituicoesFab = false;
      this.showEntidadesFinanciadorasFab = false;
      this.showAreasInterdisciplinaresFab = false;
      this.showParametrosDiversosFab = true;
    }
  };

  item = (opt, choice, updateFunction) => {
    opt.items = choice;
    updateFunction();
  };

  page = (opt, sum, updateFunction) => {
    opt.page += sum;
    if (opt.page < 1)
      opt.page = 1;
    if (opt.page > Math.ceil(opt.total / opt.items))
      opt.page = Math.ceil(opt.total / opt.items);
    updateFunction();
  };


  // Instituições
  getInstituicoes = () => {
    this.instituicoesLoading = true;
    let include = {relation: 'pais'};
    this.AdministrationService.getPagedData(this.Instituicao, this.optInstituicoes, include).then(instituicoes => {
      this.instituicoes = instituicoes;
      this.instituicoesLoading = false;

      let page = this.optInstituicoes.page;
      let items = this.optInstituicoes.items;

      // total is updated in service

      this.optInstituicoes.start = this.optInstituicoes.total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optInstituicoes.start - 1 + items) >= this.optInstituicoes.total) {
        this.optInstituicoes.end = this.optInstituicoes.total;
      } else {
        this.optInstituicoes.end = Number.parseInt(this.optInstituicoes.start - 1 + items);
      }
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a ligação");
    });
  };

  addInstituicao = () => {
    let wait = this.UI.showWaiting();
    this.Pais.find({
      filter: {
        where: {
        },
        order: 'ordem ASC'
      }
    }).$promise.then((paises) => {
      wait.close();
      let instance = this.UI.showDialog({
        size: 'lg',
        template: require('./edit.instituicao.dialog.html'),
        controller: ['$scope', function ($scope) {
          $scope.instituicao = {};
          $scope.instituicao.id = 0;
          $scope.paises = paises;
          $scope.label = "Adicionar Instituição";

          $scope.auxPais = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = function () {
            // Send scope values for processing
            $scope.$close($scope);
          };

          $scope.cancel = function () {
            $scope.$dismiss('cancel');
          };
        }]
      });

      instance.then((ok) => {
        this.instituicoesLoading = true;
        // Check if part already exists with that localizacao
        ok.instituicao.pais = ok.auxPais.selected;
        ok.instituicao.paisId = ok.auxPais.selected.id;
        this.Instituicao.create(ok.instituicao).$promise.then(r => {
          this.getInstituicoes();
          this.UI.addToast("Instituição inserida com sucesso.");
        }).catch(error => {
          console.log(error);
          this.instituicoesLoading = false;
          this.UI.addToast("Erro de criação. Verifique a ligação.");
        });
      }, (err) => {
        // Error in opening modal or closing it with Esc or clicking outside. Do nothing.
        if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
          console.log(err);
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler países para inserir instituições. Verifique a ligação");
    });
  };

  editInstituicao = (x) => {
    let wait = this.UI.showWaiting();
    this.Pais.find({
      filter: {
        where: {
        },
        order: 'ordem ASC'
      }
    }).$promise.then((paises) => {
      this.Instituicao.findOne({
        filter: {
          where: {
            id: x.id
          },
          include: ['pais']
        }
      }).$promise.then((instituicao) => {
        wait.close();
        if (instituicao !== null) {
          let options = {
            size: 'lg',
            template: require('./edit.instituicao.dialog.html'),
            controller: ['$scope', '$dialog', function ($scope, $dialog) {
              $scope.instituicao = angular.copy(instituicao);
              $scope.label = "Editar Instituição";
              $scope.paises = paises;

              $scope.auxPais = {
                selected: $scope.instituicao.pais,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              // Infinite Scroll magic
              $scope.addMoreItems = (infiniteScroll) => {
                infiniteScroll.currentItems += infiniteScroll.numToAdd;
              };

              $scope.ok = () => {
                $dialog.close($scope);
              };

              $scope.cancel = () => {
                $dialog.dismiss('cancel');
              };
            }]
          };
          let dialogEdit = this.UI.showDialog(options);

          dialogEdit.then((ok) => {
            this.instituicoesLoading = true;
            this.Instituicao.findOne({
              filter: {
                where: {
                  id: ok.instituicao.id
                }
              }
            }).$promise.then((p) => {
              x.designacao = ok.instituicao.designacao;
              x.pais = ok.auxPais.selected;
              x.paisId = ok.auxPais.selected.id;
              x.$save().then((res) => {
                this.UI.addToast('Instituição alterada com sucesso');
                this.getInstituicoes();
              }).catch((error) => {
                console.log(error);
                this.UI.addToast('Erro ao guardar instituição. Verifique a ligação');
                this.getInstituicoes();
              });
            }).catch((error) => {
              console.log(error);
              this.UI.addToast('Instituição não encontrada');
              this.getInstituicoes();
            });
          });
        } else {
          this.UI.addToast('Instituição não encontrada');
          this.getInstituicoes();
        }
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast('Erro na procura de instituição. Verifique a ligação');
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler países para editar instituição. Verifique a ligação");
    });
  };

  // checkDeleteLocalizacao = (i) => {
  //   let cenas = this.UI.showWaiting();
  //   this.Localizacao.findOne({
  //     filter: {
  //       where: {
  //         id: i.id,
  //         active: 1
  //       }
  //     }
  //   }).$promise.then((localizacaoToRemove) => {
  //     // Find if we have something that might block deletion
  //     this.Edificio.count({
  //       fields: {id: true, localizacaoId: true, active: true},
  //       where: {
  //         localizacaoId: localizacaoToRemove.id,
  //         active: 1
  //       }
  //     }).$promise.then((localizacoes) => {
  //       cenas.close();
  //       if (localizacoes.count > 0) {
  //         let msg = "Não é possível remover localização.\nExiste" + ((localizacoes.count > 1) ? "m " : " ");
  //         msg += localizacoes.count > 0 ? (localizacoes.count + " edifício" + (localizacoes.count !== 1 ? "s " : " ")) : "";
  //         msg += "com esta localização.";
  //         this.UI.showAlert(msg);
  //       } else {
  //         this.confirmDeleteLocalizacao(i);
  //       }
  //     }).catch((error) => {
  //       console.log(error);
  //       this.UI.addToast("De momento não é possível remover localização. Por favor tente mais tarde");
  //     });
  //   }).catch(error => {
  //     console.log(error);
  //     this.UI.addToast("De momento não é possível remover localização. Por favor tente mais tarde");
  //   });
  // };

  // confirmDeleteLocalizacao = (i) => {
  //   let title = "Eliminar Localização";
  //   let warning = "Tem a certeza que pretende remover esta localização?";
  //   let instance = this.UI.showDialog({
  //     size: 'lg',
  //     template: require('../../interface/modals/delete-selected.html'),
  //     controller: ['$scope', function ($scope) {
  //       $scope.title = title;
  //       $scope.message = warning;
  //       $scope.ok = function () {
  //         $scope.$close();
  //       };
  //       $scope.cancel = function () {
  //         $scope.$dismiss('cancel');
  //       };
  //     }]
  //   });
  //
  //   instance.then(() => {
  //     this.removeLocalizacao(i);
  //   }, (err) => {
  //     if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
  //       console.log(err);
  //   });
  // };

  // removeLocalizacao = (s) => {
  //   this.localizacoesLoading = true;
  //   // Find again localizacao to delete so we can update it
  //   this.Localizacao.findOne({
  //     filter: {
  //       where: {
  //         id: s.id,
  //         active: 1
  //       }
  //     }
  //   }).$promise.then((localizacao) => {
  //     localizacao.active = 0;
  //     localizacao.$save().then((res) => {
  //       this.UI.addToast("Localização eliminada com sucesso!");
  //       this.getLocalizacoes();
  //     }, (error) => {
  //       console.log(error);
  //       this.getLocalizacoes();
  //       this.UI.addToast("Erro de eliminação. Por favor tente mais tarde.");
  //     });
  //   }).catch((error) => {
  //     console.log(error);
  //     this.getLocalizacoes();
  //     this.UI.addToast("Não foi possível eliminar localização. Verifique se ainda existe.");
  //   });
  // };


  // Entidades Financiadoras
  getEntidadesFinanciadoras = () => {
    this.entidadesFinanciadorasLoading = true;
    let include = {relation: 'pais'};
    this.AdministrationService.getPagedData(this.EntidadeFinanciadora, this.optEntidadesFinanciadoras, include).then(entidadesFinanciadoras => {
      this.entidadesFinanciadoras = entidadesFinanciadoras;
      this.entidadesFinanciadorasLoading = false;

      let page = this.optEntidadesFinanciadoras.page;
      let items = this.optEntidadesFinanciadoras.items;

      // total is updated in service

      this.optEntidadesFinanciadoras.start = this.optEntidadesFinanciadoras.total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optEntidadesFinanciadoras.start - 1 + items) >= this.optEntidadesFinanciadoras.total) {
        this.optEntidadesFinanciadoras.end = this.optEntidadesFinanciadoras.total;
      } else {
        this.optEntidadesFinanciadoras.end = Number.parseInt(this.optEntidadesFinanciadoras.start - 1 + items);
      }
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler entidades financiadoras. Verifique a ligação");
    });
  };

  addEntidadeFinanciadora = () => {
    let wait = this.UI.showWaiting();
    this.Pais.find({
      filter: {
        where: {
        },
        order: 'ordem ASC'
      }
    }).$promise.then((paises) => {
      wait.close();
      let instance = this.UI.showDialog({
        size: 'lg',
        template: require('./edit.entidade.financiadora.dialog.html'),
        controller: ['$scope', function ($scope) {
          $scope.entidadeFinanciadora = {};
          $scope.entidadeFinanciadora.id = 0;
          $scope.paises = paises;
          $scope.label = "Adicionar Entidade Financiadora";

          $scope.auxPais = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = function () {
            // Send scope values for processing
            $scope.$close($scope);
          };

          $scope.cancel = function () {
            $scope.$dismiss('cancel');
          };
        }]
      });

      instance.then((ok) => {
        this.entidadesFinanciadorasLoading = true;
        ok.entidadeFinanciadora.designacao = ok.entidadeFinanciadora.designacao.trim();
        // Check if it already exists
        this.AdministrationService.usedPartialDataForModel({
          designacao: ok.entidadeFinanciadora.designacao,
          paisId: ok.auxPais.selected.id
        }, this.EntidadeFinanciadora).then(res => {
          if (res.count > 0) { // Already exists
            this.UI.addToast("Entidade Financiadora já existe");
            this.entidadesFinanciadorasLoading = false;
          } else { // Create it
            ok.entidadeFinanciadora.pais = ok.auxPais.selected;
            ok.entidadeFinanciadora.paisId = ok.auxPais.selected.id;
            this.EntidadeFinanciadora.create(ok.entidadeFinanciadora).$promise.then(r => {
              this.getEntidadesFinanciadoras();
              this.UI.addToast("Entidade Financiadora inserida com sucesso.");
            }).catch(error => {
              console.log(error);
              this.entidadesFinanciadorasLoading = false;
              this.UI.addToast("Erro de criação. Verifique a ligação.");
            });
          }
        }).catch((error) => {
          this.entidadesFinanciadorasLoading = false;
          this.UI.addToast("Erro de criação. Verifique a ligação.");
          console.log(error);
        });
      }, (err) => {
        // Error in opening modal or closing it with Esc or clicking outside. Do nothing.
        if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
          console.log(err);
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler países para inserir entidades. Verifique a ligação");
    });
  };

  editEntidadeFinanciadora = (x) => {
    let wait = this.UI.showWaiting();
    this.Pais.find({
      filter: {
        where: {
        },
        order: 'ordem ASC'
      }
    }).$promise.then((paises) => {
      this.EntidadeFinanciadora.findOne({
        filter: {
          where: {
            id: x.id
          },
          include: ['pais']
        }
      }).$promise.then((entidadeFinanciadora) => {
        wait.close();
        if (entidadeFinanciadora !== null) {
          let options = {
            size: 'lg',
            template: require('./edit.entidade.financiadora.dialog.html'),
            controller: ['$scope', '$dialog', function ($scope, $dialog) {
              $scope.entidadeFinanciadora = angular.copy(entidadeFinanciadora);
              $scope.label = "Editar Entidade Financiadora";
              $scope.paises = paises;

              $scope.auxPais = {
                selected: $scope.entidadeFinanciadora.pais,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              // Infinite Scroll magic
              $scope.addMoreItems = (infiniteScroll) => {
                infiniteScroll.currentItems += infiniteScroll.numToAdd;
              };

              $scope.ok = () => {
                $dialog.close($scope);
              };

              $scope.cancel = () => {
                $dialog.dismiss('cancel');
              };
            }]
          };
          let dialogEdit = this.UI.showDialog(options);

          dialogEdit.then((ok) => {
            this.entidadesFinanciadorasLoading = true;
            ok.entidadeFinanciadora.designacao = ok.entidadeFinanciadora.designacao.trim();

            this.EntidadeFinanciadora.findOne({
              filter: {
                where: {
                  id: ok.entidadeFinanciadora.id
                }
              }
            }).$promise.then((y) => {
              // Check if data is already used
              this.AdministrationService.usedPartialDataForModel({
                designacao: ok.entidadeFinanciadora.designacao,
                paisId: ok.auxPais.selected.id
              }, this.EntidadeFinanciadora, y.id).then(res => {
                if (res.count > 0) { // Already exists
                  this.UI.addToast("Entidade Financiadora já existe");
                  this.entidadesFinanciadorasLoading = false;
                } else { // It's ok to edit
                  y.designacao = ok.entidadeFinanciadora.designacao;
                  y.pais = ok.auxPais.selected;
                  y.paisId = ok.auxPais.selected.id;
                  y.$save().then((res) => {
                    this.UI.addToast('Entidade Financiadora alterada com sucesso');
                    this.getEntidadesFinanciadoras();
                  }).catch((error) => {
                    console.log(error);
                    this.UI.addToast('Erro ao guardar entidade financiadora. Verifique a ligação');
                    this.getEntidadesFinanciadoras();
                  });
                }
              }).catch(error => {
                console.log(error);
                this.UI.addToast('Entidade Financiadora não encontrada');
                this.getEntidadesFinanciadoras();
              });
            }).catch((error) => {
              console.log(error);
              this.UI.addToast('Entidade Financiadora não encontrada');
              this.getEntidadesFinanciadoras();
            });
          });
        } else {
          this.UI.addToast('Entidade Financiadora não encontrada');
          this.getEntidadesFinanciadoras();
        }
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast('Erro na procura de entidade financiadora. Verifique a ligação');
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler países para editar entidade financiadora. Verifique a ligação");
    });
  };


  // Áreas Interdisciplinares
  getAreasInterdisciplinares = () => {
    this.areasInterdisciplinaresLoading = true;
    this.AdministrationService.getPagedData(this.AreaInterdisciplinar, this.optAreasInterdisciplinares).then(areasInterdisciplinares => {
      this.areasInterdisciplinares = areasInterdisciplinares;
      this.areasInterdisciplinaresLoading = false;

      let page = this.optAreasInterdisciplinares.page;
      let items = this.optAreasInterdisciplinares.items;

      // total is updated in service

      this.optAreasInterdisciplinares.start = this.optAreasInterdisciplinares.total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optAreasInterdisciplinares.start - 1 + items) >= this.optAreasInterdisciplinares.total) {
        this.optAreasInterdisciplinares.end = this.optAreasInterdisciplinares.total;
      } else {
        this.optAreasInterdisciplinares.end = Number.parseInt(this.optAreasInterdisciplinares.start - 1 + items);
      }
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas interdisciplinares. Verifique a ligação");
    });
  };

  addAreaInterdisciplinar = () => {
    let instance = this.UI.showDialog({
      size: 'lg',
      template: require('./edit.area.interdisciplinar.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.areaInterdisciplinar = {};
        $scope.areaInterdisciplinar.id = 0;
        $scope.label = "Adicionar Entidade Financiadora";

        $scope.ok = function () {
          // Send scope values for processing
          $scope.$close($scope);
        };

        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then((ok) => {
      this.areasInterdisciplinaresLoading = true;
      ok.areaInterdisciplinar.designacao = ok.areaInterdisciplinar.designacao.trim(); // Strip white spaces before and after
      // Check if it already exists
      this.AdministrationService.usedPartialDataForModel({designacao: ok.areaInterdisciplinar.designacao}, this.AreaInterdisciplinar).then(res => {
        if (res.count > 0) { // Already exists
          this.UI.addToast("Área Interdiscilinar já existe");
          this.areasInterdisciplinaresLoading = false;
        } else { // Create it
          this.AreaInterdisciplinar.create(ok.areaInterdisciplinar).$promise.then(r => {
            this.getAreasInterdisciplinares();
            this.UI.addToast("Área Interdisciplinar inserida com sucesso.");
          }).catch(error => {
            console.log(error);
            this.areasInterdisciplinaresLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
          });
        }
      }).catch((error) => {
        this.areasInterdisciplinaresLoading = false;
        this.UI.addToast("Erro de criação. Verifique a ligação.");
        console.log(error);
      });
    }, (err) => {
      // Error in opening modal or closing it with Esc or clicking outside. Do nothing.
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    });
  };

  editAreaInterdisciplinar = (x) => {
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((areaInterdisciplinar) => {
      wait.close();
      if (areaInterdisciplinar !== null) {
        let options = {
          size: 'lg',
          template: require('./edit.area.interdisciplinar.dialog.html'),
          controller: ['$scope', '$dialog', function ($scope, $dialog) {
            $scope.areaInterdisciplinar = angular.copy(areaInterdisciplinar);
            $scope.label = "Editar Área Interdisciplinar";

            $scope.ok = () => {
              $dialog.close($scope);
            };

            $scope.cancel = () => {
              $dialog.dismiss('cancel');
            };
          }]
        };
        let dialogEdit = this.UI.showDialog(options);

        dialogEdit.then((ok) => {
          this.areasInterdisciplinaresLoading = true;
          ok.areaInterdisciplinar.designacao = ok.areaInterdisciplinar.designacao.trim();
          this.AreaInterdisciplinar.findOne({
            filter: {
              where: {
                id: ok.areaInterdisciplinar.id
              }
            }
          }).$promise.then((y) => {
            // Check if data is already used
            this.AdministrationService.usedPartialDataForModel({designacao: ok.areaInterdisciplinar.designacao}, this.AreaInterdisciplinar, y.id).then(res => {
              if (res.count > 0) { // Already exists
                this.UI.addToast("Área Interdiscilinar já existe");
                this.areasInterdisciplinaresLoading = false;
              } else { // It's ok to edit
                y.designacao = ok.areaInterdisciplinar.designacao;
                y.$save().then((res) => {
                  this.UI.addToast('Área Interdiscilinar alterada com sucesso');
                  this.getAreasInterdisciplinares();
                }).catch((error) => {
                  console.log(error);
                  this.UI.addToast('Erro ao guardar área interdiscilinar. Verifique a ligação');
                  this.getAreasInterdisciplinares();
                });
              }
            }).catch(error => {
              console.log(error);
              this.UI.addToast('Área Interdiscilinar não encontrada');
              this.getAreasInterdisciplinares();
            });
          }).catch((error) => {
            console.log(error);
            this.UI.addToast('Área Interdiscilinar não encontrada');
            this.getAreasInterdisciplinares();
          });
        });
      } else {
        this.UI.addToast('Entidade Financiadora não encontrada');
        this.getAreasInterdisciplinares();
      }
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast('Erro na procura de área interdisciplinar. Verifique a ligação');
    });
  };


  // Parâmetros Diversos
  getParametrosDiversos = () => {
    this.parametrosDiversosLoading = true;
    this.ParametrosDiversos.find({
      filter: {
        order: 'ano DESC'
      }
    }).$promise.then((parametrosDiversos) => {
      this.parametrosDiversos = parametrosDiversos;
      if (this.parametrosDiversos.length > 0) {
        // Use the first one to display
        this.anos = [];
        this.parametrosDiversos.forEach(p => {
          this.anos.push({
            id: p.ano,
            ano: p.ano
          });
        });
        this.auxAno = {
          selected: {id: this.parametrosDiversos[0].ano, ano: this.parametrosDiversos[0].ano},
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        this.focusParametros = this.parametrosDiversos[0]; // By default show first
      }
      this.parametrosDiversosLoading = false;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler parâmetros. Verifique a sua ligação");
      this.parametrosDiversosLoading = false;
    });
  };

  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  onAnoSelected = (ano) => {
    this.focusParametros = this.parametrosDiversos.find(x => x.ano === ano.ano);
  };

  addParametrosDiversos = () => {
    let wait = this.UI.showWaiting();
    let currentYear = moment().format('YYYY');
    let anosDisponiveis = Array(currentYear - 2000 + 1).fill().map((x, i) => currentYear - i);
    this.ParametrosDiversos.find({
      filter: {
        fields: {ano: true}
      }
    }).$promise.then((anosUsados) => {
      wait.close();
      if (anosUsados && anosUsados.length > 0) {
        anosUsados.forEach(a => {
          let index = anosDisponiveis.indexOf(a.ano);
          if (index > -1) anosDisponiveis.splice(index, 1);
        });
      }

      let options = {
        size: 'lg',
        template: require('./edit.parametros.diversos.dialog.html'),
        controller: ['$scope', '$dialog', function ($scope, $dialog) {
          $scope.isEditing = false;
          $scope.anos = anosDisponiveis.map(a => {
            return {id: a, ano: a}
          });
          $scope.parametros = {};
          $scope.label = "Novos Parâmetros Diversos";

          $scope.auxAno = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then((ok) => {
        if (ok.auxAno && ok.parametros) {
          ok.parametros.ano = ok.auxAno.selected.id;
          this.parametrosDiversosLoading = true;
          this.ParametrosDiversos.find({
            filter: {
              where: {
                ano: ok.parametros.ano
              }
            }
          }).$promise.then((res) => {
            if (res && res.length > 0) {
              this.parametrosDiversosLoading = false;
              this.UI.showAlert("Já existem parâmetros diversos registados para o ano " + ok.parametros.ano + ". Recarregue a página");
            } else {
              ok.parametros.id = 0;
              ok.parametros.criadoPorId = this.user.id;
              ok.parametros.dataCriacao = moment().format();
              this.ParametrosDiversos.create(ok.parametros).$promise.then((p) => {
                this.UI.addToast("Parâmetros diversos inseridos com sucesso");
                this.getParametrosDiversos();
              }).catch((error) => {
                console.log(error);
                this.UI.showAlert("Não foi possível criar parâmetros. Verifique a sua ligação");
                this.parametrosDiversosLoading = false;
              });
            }
          }).catch((error) => {
            console.log(error);
            this.parametrosDiversosLoading = false;
            this.UI.addToast("Não foi possível consultar lista de parâmetros diversos. Verifique a sua ligação");
          });
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível consultar parâmetros diversos. Verifique a sua ligação");
    });
  };

  editParametrosDiversos = (parametros) => {
    let options = {
      size: 'lg',
      template: require('./edit.parametros.diversos.dialog.html'),
      controller: ['$scope', '$dialog', function ($scope, $dialog) {
        $scope.isEditing = true;
        $scope.anos = [{id: parametros.ano, ano: parametros.ano}];
        $scope.parametros = angular.copy(parametros);

        $scope.label = "Editar Parâmetros Diversos";

        $scope.auxAno = {
          selected: {id: parametros.ano, ano: parametros.ano},
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then((ok) => {
      if (ok.auxAno && ok.parametros) {
        ok.parametros.ano = ok.auxAno.selected.id;
        this.parametrosDiversosLoading = true;
        this.ParametrosDiversos.find({
          filter: {
            where: {
              and: [{ano: ok.parametros.ano}, {id: {neq: ok.parametros.id}}]
            }
          }
        }).$promise.then((res) => {
          if (res && res.length > 0) {
            this.parametrosDiversosLoading = false;
            this.UI.showAlert("Já existem parâmetros diversos registados para o ano " + ok.parametros.ano + ". Recarregue a página");
          } else {
            angular.extend(parametros, ok.parametros);
            ok.parametros.criadoPorId = this.user.id;
            ok.parametros.dataCriacao = moment().format();
            this.ParametrosDiversos.upsert(parametros).$promise.then((p) => {
              this.UI.addToast("Parâmetros diversos editados com sucesso");
              this.getParametrosDiversos();
            }).catch((error) => {
              console.log(error);
              this.UI.showAlert("Não foi possível editar parâmetros. Verifique a sua ligação");
              this.parametrosDiversosLoading = false;
            });
          }
        }).catch((error) => {
          console.log(error);
          this.parametrosDiversosLoading = false;
          this.UI.addToast("Não foi possível consultar lista de parâmetros diversos. Verifique a sua ligação");
        });
      }
    });
  }

}

ConfigParametrosController.$inject = ['$q', 'AuthenticationService', 'AdministrationService', 'UIService', 'Instituicao', 'EntidadeFinanciadora', 'AreaInterdisciplinar', 'ParametrosDiversos', 'Pais'];
